// extracted by mini-css-extract-plugin
module.exports = {"graySection":"PlanSnapshotSection_graySection__22oVo"};